import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SeriesLineItem from './SeriesLineItem';
import moment from 'moment';
import Skeleton from 'shared/Skeleton';
import { hourMinute, weekDayMonthDayYearShort } from '@showclix-shared-intl/dateTimeFormatters';
import { eventInFilterResults } from '../../../helpers/series';

export default class ListTimePicker extends Component {
    render() {
        return (
            <Fragment>
                {this.props.loading &&
                    <div className="event__times__group">
                        <div className="card-group">
                            <div className="card">
                                <Skeleton height="13px" width="166px" />
                            </div>
                            <div className="card">
                                <Skeleton height="10px" width="70px" />
                            </div>
                            <div className="card">
                                <Skeleton height="10px" width="100px" />
                            </div>
                        </div>
                        <div className="card-group">
                            <div className="card">
                                <Skeleton height="13px" width="166px" />
                            </div>
                            <div className="card">
                                <Skeleton height="10px" width="70px" />
                            </div>
                            <div className="card">
                                <Skeleton height="10px" width="100px" />
                            </div>
                        </div>
                        <div className="card-group">
                            <div className="card">
                                <Skeleton height="13px" width="166px" />
                            </div>
                            <div className="card">
                                <Skeleton height="10px" width="70px" />
                            </div>
                            <div className="card">
                                <Skeleton height="10px" width="100px" />
                            </div>
                        </div>
                    </div>
                }
                {this.renderEvents()}
            </Fragment>
        )
    }

    renderEvents = () => {
        return Object.keys(this.props.eventTimes).map((date, i) => {
            const time = new Date(date);
            const timeString = weekDayMonthDayYearShort(this.props.locale, time);
            const firstAvailableItem = this.props.eventTimes[date].find(times => times.eventStatus === 'on_sale')?.id;
            return <div className="event__times__group" key={i}>
                <div className="card-group">
                    {!this.props.selectedDay && <div className="card">
                        <div className="list-date-picker__card-date">
                            <time dateTime={timeString}>{timeString}</time>
                        </div>
                    </div>}
                    {this.props.eventTimes[date].map((event, j) => {
                        return <SeriesLineItem
                            key={'' + i + j}
                            time={event.time}
                            endTime={event.endTime}
                            id={event.id}
                            onClick={this.props.onEventSelected}
                            selected={this.props.selectedChildEvent === Number(event.id)}
                            eventStatus={event.eventStatus}
                            showSoldOut={this.props.showSoldOut}
                            eventInventory={+event.inventory}
                            locale={this.props.locale}
                            filtered={this.props.hasActiveInventoryFilter && this.props.inventoryFilterResults && !eventInFilterResults(+event.id, this.props.inventoryFilterResults)}
                            autoFocus={event.id === firstAvailableItem}
                            seriesChildAdditionalInfo={event.childEventAdditionalInfo}
                        />
                    })}
                </div>
            </div>
        });
    }
}

ListTimePicker.propTypes = {
    eventTimes: PropTypes.object,
    loading: PropTypes.bool,
    selectedChildEvent: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
    showSoldOut: PropTypes.bool,
    onEventSelected: PropTypes.func.isRequired,
};
